Vue.component('nodo-buttons', {
  name: 'nodo-buttons',
  props: ['currentnodo', 'options', "labellang"],
  template: '<div v-if="isActive" id="buttons-node">' +
  '<div v-if="nodeQuestion" v-bind:class="currentnodo.from">' +
  '<div class="row bubble-agent col-xs-11">' +
  '<div class="col-xs-3 text-center"><img class="img-agent" :src="getImgAgent(currentnodo.agentType)"  :class="setClassAgent(currentnodo.agentType)" onerror="svgOnError()"><span v-if="timeShow" class="time">{{ currentnodo.currentTime }}</span></div>' +
  '<div class="col-xs-9 no-gutters"><div class="msg-text" v-html="nodeQuestion"></div><p class="name">{{ currentnodo.name }}</span></p>' +
  '</div>' +
  '</div>' +
  // Il bottone con select/deselect
  '<div v-if="isMultipleSelection" class="box-nodo-menu offset-top-10 select-all-container">'+
  '<div @click="selectAllButtons()">'+
  '<button :style="selectAll?\'background-color:#666\':\'background-color:#4B95CE\'">'+
  '<i class="convy-submit-icon material-icons">{{ selectAll ? \'done\' : \'clear\' }} </i>'+
  '</button>'+
  '<span>{{ selectAll ? labellang.selectAll : labellang.deselectAll }} </span>'+
  '</div>'+
  '</div>'+
  '<div>'+
  // Carosello di immagini
  '<div class="swiper-container swiper-buttons nodo-menu-slide" v-if="templateSlider" v-bind:id="currentID">' +
  '<div class="swiper-wrapper">' +
  '<div class="swiper-slide" v-for="(item,index) in getButtonsList">' +
  '<div class="row">' +
  '<div v-if="item.image" class="thumb" :style="getUrlBgImg(item.image)"><a v-if="hasImgLink(item.image)" :style="getCarouselHeight"  :href="item.image | checkIfImgBase64" target="_blank"></a></div>' +
  '<div v-else class="thumb empthy" ><a v-if="hasImgLink(item.media_url)" :style="getHeightImg()"  :href="item.image | checkIfImgBase64" target="_blank"></a></div>' +
  '<button v-if="item.label && !isMultipleSelection" @click="callLink(item,currentID)" class="btn btn-media text-left" :style="getCarouselHeight" style="padding-left:20px; padding-right:20px;" :class="checkIsSelected(item.label)" :title="item.label" v-html="truncateFunction(item.label)"></button>' +
  '<div v-else @click="callLink(item,currentID)" class="checkbox-container carousel-image" :style="getCarouselHeight">'+
  '<label v-if="isMultipleSelection" class="material-checkbox checkbox-hidden">'+
  '<input type="checkbox" class="material-checkbox-input" :class="item.label" disabled>'+
  '<span></span>'+
  '</label>'+
  '<div class="checkbox-text carousel-text"><span v-html="item.label"></span></div>'+
  '</div>'+
  '</div>' +
  '</div>' +
  '</div>' +
  '<div class="swiper-pagination2" v-if="pagination"></div>' +
  '<div class="swiper-button-next2" v-if="swipeNext"></div>' +
  '<div class="swiper-button-prev2" v-if="swipePrev"></div>' +
  '</div>' +
  //senza immagini
  '<div class="box-nodo-menu nodo-menu-label text-center offset-top-10" v-if="templateMenu">' +
  '<div v-for="(item,index) in getButtonsList" @click="callLink(item,currentID)" class="item order-item" :class="checkIsSelected(item.label)" :style="{ width: getWidth }" :title="this.titleTooltip" ><img v-if="item.icon_url" class="iconurl" :src="item.icon_url">'+
  '<span v-if="!isMultipleSelection" v-html="item.label"></span>'+
  '<div class="checkbox-container" v-else style="padding-left:0px 8px">'+
  '<label v-if="isMultipleSelection" class="material-checkbox checkbox-hidden">'+
  '<input type="checkbox" class="material-checkbox-input" :class="item.label" disabled>'+
  '<span></span>'+
  '</label>'+
  '<div class="checkbox-text"><span v-html="item.label"></span></div>'+
  '</div>'+
  '</div>'+
  '</div>' +
  // Se la search è enabled e ci sono bottoni nascosti
  '<div v-if="Object.keys(invisibleButtons).length>0" class="box-nodo-menu dropdown" :style="templateSlider?\'margin: 15px 0;\':\'\'">'+
  '<button type="button" data-toggle="dropdown" class="btn btn-default dropdown-toggle" :class="selectAll?\'\':\'selectAllOptions\'">'+
  '<span> {{ selectAll ? labellang.otherOptions : labellang.allSelected }} </span>'+
  '<span class="caret"></span>'+
  '</button>'+
  '<div class="dropdown-menu" @click="stop($event)">'+
  '<div class="searchbar" v-if="Object.keys(invisibleButtons).length>5">'+
  '<input type="text" v-model="searchString" :placeholder="labellang.search"  @input="searchForButtons">'+
  '<button type="submit"><i class="material-icons">search</i></button>'+
  '</div>'+
  '<div v-for="(item, index) in invisibleButtons" @click="callLink(item,currentID)" @mouseover="showColor = item.label+\'-\'+index" @mouseleave="showColor = null" v-show="item.visible" class="checkbox-search" :style="Object.keys(invisibleButtons).length>5?\'\':\'padding-top:15px\'">'+
  '<label class="material-checkbox" :class="showColor==item.label+\'-\'+index?\'checkbox-color\':\'\'" v-if="isMultipleSelection" >'+
  '<input type="checkbox" class="material-checkbox-input" :class="item.label" disabled>'+
  '<span></span>'+
  '</label>'+
  '<div class="checkbox-text-grey" :class="showColor==item.label+\'-\'+index?\'checkbox-color\':\'\'">{{item.label}}</div>'+
  '</div>'+  
  '</div>'+
  '</div>'+
  '</div>' +
  '</div>'+
  //Il div sotto serve per mantenere il bottone di back e quello di save nella giusta
  '<div style="display:flex;width: 100%;margin-bottom:12px"></div>',
// template: '<div>test{{this.msg}}</div> ',
  data: function () {
    return {
      nodoMenu: this.currentnodo.msg,
      nodeQuestion: this.currentnodo.msg.attributes.question,
      isMultipleSelection: this.currentnodo.msg.attributes.isMultipleSelection,
      showColor:null,
      searchString:'',
      selectAll:true,
      isActive: false,
      prepend: false,
      nodoComplete: false,
      currentID: null,
      truncateCharacter: 17,
      pagination: true,
      swipeNext: true,
      swipePrev: true,
      mediaUrl: null,
      thumb: false,
      templateSlider: false,
      templateMenu: false,
      titTooltip: '',
      btTooltip: ',',
      getWidth: "100%",
      nodoMenuObject: [],
      invisibleButtons: [],
      currentTitle: null,
      oneItem: false,
      heightImg: 100,
      imgCustomer: this.options.imgCustomer,
      imgAgent: this.options.imgAgent,
      imgFailCustomer: this.options.imgFailCustomer,
      imgFailAgent: this.options.imgFailAgent,
      timeShow: true,
      maxWordLen: -1,
      swiperTmp: null,
      carouselHeight:50,
      optionSliderMenu: {
        pagination: '.swiper-pagination2',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 5,
        simulateTouch: false,
        nextButton: '.swiper-button-next2',
        prevButton: '.swiper-button-prev2',
        breakpoints: {
          // when window width is <= 320px
          420: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          // when window width is <= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 20
          },
        }
      },
      currentButtonsChoice: []
    }
  },
  created: function () {
    this.checkTemplate();
    this.checkElement();
    bus.$emit("onInputMsgDisabled", true);
    if(this.isMultipleSelection){
      bus.$emit("showSubmitButton", false);
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      var elId = "#" + this.currentID;
       if (!this.oneItem) { // if more item init swiper
        var swiper2 = new Swiper(elId, this.optionSliderMenu);
        this.swiperTmp = swiper2;
      }
    });
    
    bus.$on('submitButtonsChoice', this.submitButtonsChoice);
    bus.$on('newUserEventLS', this.closeButtonsChoice);
  },
  filters: {
  truncateCaption: function (value) {
      var text = value;
      if (value.length > this.truncateCharacter) {
        text = text.substr(0, this.truncateCharacter - 3) + "...";
      }
      return text;
    },
    checkIfImgBase64: function (img) {
      if (img.indexOf("base64") != -1) {
        return false;
      }
      return img;
    }
  },
  computed: {
    getButtonsList: function (){
      var filtredObj=[];
      if (this.nodoMenu.attributes.isSearchEnabled) {
        var manageButtons = this.checkIfNumber(this.nodoMenu.attributes.number_of_visible_buttons);
        var numberOfInvisibleButtons = Object.keys(this.nodoMenuObject).length - manageButtons;
        if(manageButtons >0 && numberOfInvisibleButtons>0) {
          for(var el in Object.keys(this.nodoMenuObject)){
            if (el < manageButtons) {
              filtredObj.push(this.nodoMenuObject[el]);
            } else {
              this.invisibleButtons.push(this.nodoMenuObject[el]);
              this.invisibleButtons[this.invisibleButtons.indexOf(this.nodoMenuObject[el])].visible =true;
            }
          }
        } else {
          filtredObj= this.nodoMenuObject
        }
      } else {
        filtredObj = this.nodoMenuObject
      }
      for (var objKey in filtredObj){
        var obj = filtredObj[objKey];
        if(obj.label.length> this.carouselHeight) {
          this.carouselHeight = obj.label.length+18;
        }
      }
      return filtredObj
    },
    getCarouselHeight: function() {
      return  "height:"+ this.carouselHeight+"px!important"
    }
  },
  methods: {
		svgOnError:function(){
			console.log('Fail to load svg nodo buttons');
		},
    checkIfNumber:function(number){
      if (isNaN(number)) {
        var change = null;
       // Questo metodo serve per evitare un errore nel caso arrivi una variabile non contenente un numero valido per i bottoni visibili
        if (Object.keys(this.nodoMenuObject).length>4) {
          change = ( Object.keys(this.nodoMenuObject).length %2 == 0 )? (Object.keys(this.nodoMenuObject).length/2) + 1:
         ((Object.keys(this.nodoMenuObject).length-1) / 2) + 1  ;
        } else {
          change = 0;
        }
        return change
    } else {
        return Number(number);
   }
  },
    truncateFunction: function(value){
      return this.$options.filters.truncateCaption(value);
    },
    searchForButtons: function(){
      if (this.searchString==''){
        for(var el in this.invisibleButtons){
          this.invisibleButtons[el].visible = true
        }
      }
      else {
        for(var el in this.invisibleButtons){
          if (this.invisibleButtons[el].label.toLowerCase().indexOf(this.searchString.toLowerCase()) != -1){
            this.invisibleButtons[el].visible = true
          }
          else {
            this.invisibleButtons[el].visible = false
          }
        }
      }
    },
    stop:function(e){
      if (e) {
      e.stopPropagation();
      }
    },
    manageCheckboxes: function(label, manage) {
      var checkbox = document.getElementsByClassName('material-checkbox-input '+label) || document.getElementsByClassName('material-checkbox checkbox-color '+label);
      switch(manage){
        //Tolto lo stato di indeterminato perchè non lo abbiamo usato
        case 'indeterminate-check':
          checkbox[0].checked = false;
          checkbox[0].indeterminate = true;
          break;
        case 'check':
          checkbox[0].indeterminate = false;
          checkbox[0].checked = true;
          break;
        case 'uncheck':
        case 'indeterminate-uncheck':
          checkbox[0].indeterminate = false;
          checkbox[0].checked = false;
          break;
        case 'change-checked-to-indeterminate':
          for(var i=0; i < Object.keys(this.nodoMenuObject).length; i++){
            if(this.currentButtonsChoice.indexOf(this.nodoMenuObject[i].label) >= 0){
             this.manageCheckboxes(this.nodoMenuObject[i].label, 'check');
            }
          }
          this.manageCheckboxes(label, 'uncheck');
          break;
      }
      // Serve per togliere la classe nel caso non ripassi nel checkSelected
      this.checkIsSelected(label);
    },
    selectAllButtons: function() {
      if (this.selectAll) {
          for(var choice in Object.keys(this.nodoMenuObject)){
            if(this.currentButtonsChoice.indexOf(this.nodoMenuObject[choice].label) == -1) {
              this.currentButtonsChoice.push(this.nodoMenuObject[choice].label);
            }
            this.manageCheckboxes(this.nodoMenuObject[choice].label, 'check');
          }
        } else {
          for ( var choice in this.currentButtonsChoice){
            this.manageCheckboxes(this.currentButtonsChoice[choice], 'uncheck')
          }
          this.currentButtonsChoice = [];
    }
    bus.$emit("showSubmitButton", this.selectAll);
    this.selectAll = !this.selectAll;
    },
    closeButtonsChoice: function(e) {
      if(e.attributes.eventName === this.options.ConvyEvent.SYSTEM_CONVY_BUTTONS_SUBMIT) {
        //questo per evitare che tutti gli emit vengono presi anche da quelli che non dovrebbero piu essere visibili
        if ($("#" + this.currentID).length > 0) {
          bus.$emit('newMessage', {
            buttonsChoice: e.attributes[this.nodoMenu.attributes.buttonsChoiceVariable],
            skipSendMessage: true,
            from: "buttons"
          });
            $("#" + this.currentID).remove();
        }
        bus.$emit("showSubmitButton", false);
      }
    },
    submitButtonsChoice: function() {
      $("#" + this.currentID).remove();
      bus.$emit("showSubmitButton", false);
      var event = {
        eventName: this.options.ConvyEvent.SYSTEM_CONVY_BUTTONS_SUBMIT,
        parameters: {},
      };
      event.parameters[this.nodoMenu.attributes.buttonsChoiceVariable] = this.currentButtonsChoice;
      bus.$emit('newMessage', {
        buttonsChoice: this.currentButtonsChoice,
        skipSendMessage: true,
        from: "buttons"
      });
      this.options.internal.bridge.sendChatEvent(event);
    },
    checkIsSelected: function(label) {
     if(this.isMultipleSelection && this.currentButtonsChoice.indexOf(label) > -1){
        return label + "-button-choice-selected"
      }
      return "";
    },
    getNodo: function () {
      return this.nodoMenu.attributes.buttons;
    },
    getImgAgent: function (val) {
      if (val == "virtual") {
        return this.options.imgVirtualAgent;
      } else {
        return this.options.imgAgent;
      }
    },
    setClassAgent:function(val){
      return val;
    },
    hasImgLink: function (img) {
      if (img) {
        if (img.indexOf("base64") != -1) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    getHeightImg: function (url) {
      return {
        'height': this.heightImg + 'px'
      }
    },
    getUrlBgImg: function (url) {
      return {
        'background-image': 'url("' + url + '")'
      }
    },
    lenNodo: function () {
      if (this.isDefined(this.getNodo())) {
        return this.getNodo().length
      }
    },
    checkElement: function (item) {
      if (this.nodoMenu.attributes.buttons != undefined && this.nodoMenu.attributes.buttons.length == 1) {
        this.oneItem = true;
        this.resetSlider();
      }
    },
    resetSlider: function () {
      this.pagination = false;
      this.swipeNext = false;
      this.swipePrev = false;
      this.optionSliderMenu.slidesPerView = 1;
      this.optionSliderMenu.breakpoints = {
        // when window width is <= 320px
        420: {
          slidesPerView: 1
        },
        // when window width is <= 640px
        640: {
          slidesPerView: 1
        },
        1600: {
          slidesPerView: 1
        },
      }
    },
    callLink: function (item, currentNodo) {
      var that = this;
      if(that.isMultipleSelection){
        if (item.label) {
          //Se la scelta non è già contenuta nell'Array delle scelte
          if(that.currentButtonsChoice.indexOf(item.label) == -1){
            that.currentButtonsChoice.push(item.label);
              //Se ho selezionato tutte le opzioni possibili
              if(that.currentButtonsChoice.length == Object.keys(that.nodoMenuObject).length ) {
                that.selectAllButtons();
              } else { // altrimenti metto la checkbox indeterminate sulla scelta
                that.manageCheckboxes(item.label, 'check');
              }
          } else { // Se voglio eliminare le scelta fatta
            that.currentButtonsChoice.splice(that.currentButtonsChoice.indexOf(item.label), 1);
            that.manageCheckboxes(item.label, 'indeterminate-uncheck');
             if(that.currentButtonsChoice.length > 0 && !that.selectAll) {
              that.selectAll=true;
              that.manageCheckboxes(item.label, "change-checked-to-indeterminate" );
            }
            if(that.currentButtonsChoice.length == 0) {
              this.selectAll = false;
              that.selectAllButtons();
            }
          }
        }
        if(that.currentButtonsChoice.length > 0){
          bus.$emit("showSubmitButton", true);
        }else{
          bus.$emit("showSubmitButton", false);
        }
      }else {
        var buttonsChoice = [];
        if (item.label) {
          buttonsChoice.push(item.label);
        }
        $("#" + currentNodo).remove();
        var event = {
          eventName: this.options.ConvyEvent.SYSTEM_CONVY_BUTTONS_SUBMIT,
          parameters: {},
        };
        event.parameters[this.nodoMenu.attributes.buttonsChoiceVariable] = buttonsChoice;
        bus.$emit('newMessage', {
          buttonsChoice: buttonsChoice,
          skipSendMessage: true,
          from: 'buttons'
        });
        this.options.internal.bridge.sendChatEvent(event);
      }

    },
    calcWidthButton: function () {
      var setWidth = "90%";
      return setWidth;
    },
    findLongestWord: function (str) {
      var strSplit = str.split(' ');
      var longestWord = 0;
      for (var i = 0; i < strSplit.length; i++) {
        if (strSplit[i].length > longestWord) {
          longestWord = strSplit[i].length;
        }
      }
      return longestWord;
    },
    checkTemplate: function () {
      this.isActive = true;
      this.currentID = Date.now();
      this.nodoMenuObject = this.getNodo();
      var len = this.lenNodo();

      if (this.nodoMenuObject) {
        var i = 0;
        while (i < len) {
          var currentNode = this.nodoMenuObject[i];
          this.currentTitle = currentNode.label;
          this.maxWordLen = Math.max(this.maxWordLen, this.findLongestWord(this.currentTitle));
          var image = currentNode.image;
          if(image){
            this.templateSlider = true;
            break;
          }
          i += 1;
        }
        if(i === len) {
          this.templateMenu = true;
        }
      }
      this.build();
    },
    getDocumentWidth: function () {
      return document.body.offsetWidth;
    },
    matchHeight: function () {
      this.$nextTick(function () {
        $('.box-nodo-menu .item').matchHeight();
      })
    },
    build: function () {
      var win = this.getDocumentWidth();

      if (win <= 360) {
        this.truncateCharacter = 30;
      } else {
        this.truncateCharacter = 17;
      }

      this.getWidth = this.calcWidthButton(this.lenNodo());
      if (this.templateMenu) {
        this.matchHeight();
      }
    },
    getId: function () {
      return this.currentID;
    },
    isDefined: function (item) {
      return typeof item != typeof undefined && item != null;
    },

  }
})
